import { clsx } from 'helpers/utils/HTMLUtils';
import {
  ArrowRightIcon,
  Button,
  ButtonThemes,
} from 'plataforma-fundacao-componentes';
import React, { Fragment, memo } from 'react';
import './BannerAssembleia.scss';
const rootClassName = 'banner-assembleia';

interface BannerAssembleiaProps {
  imgUrl: string;
  breadCrumb?: string;
  buttonLabel: string;
  onButtonClick: (evt: any) => void;
  green?: boolean;
  text: string;
  description?: string | React.ReactNode;
}

function BannerAssembleia(props: BannerAssembleiaProps) {
  return (
    <div className={rootClassName}>
      <div
        className={clsx([`${rootClassName}-left`, props.green ? 'green' : ''])}
      >
        {props.breadCrumb ? (
          <div className={`${rootClassName}-bread-crumb`}>
            {props.breadCrumb}
          </div>
        ) : undefined}
        <div
          className={clsx([
            `${rootClassName}-text`,
            props.green ? 'white' : '',
          ])}
        >
          {props.text}
          {props.description ? (
            <Fragment>
              <br />
              <span>{props.description}</span>
            </Fragment>
          ) : undefined}
        </div>
        <div className={`${rootClassName}-button`}>
          <Button
            onClick={props.onButtonClick}
            theme={ButtonThemes.DefaultPrimary}
            rightIcon={<ArrowRightIcon />}
            className={props.green ? 'white' : ''}
          >
            {props.buttonLabel}
          </Button>
        </div>
      </div>
      <div
        className={`${rootClassName}-imagem`}
        style={
          props.green
            ? {
                backgroundImage: `linear-gradient(30deg, rgba(63,161,16,0.3701855742296919) 0%, rgba(63,161,16,0) 50%), url(${props.imgUrl})`,
              }
            : { backgroundImage: `url(${props.imgUrl})` }
        }
      >
        <img alt='img' src={props.imgUrl} />
      </div>
    </div>
  );
}

export default memo(BannerAssembleia);
